<template>
  <div class="userManage">
    <div class="userHeader">
      <div class="searchBox">
        <div class="searchInfo">
          <div class="searchText">{{ $t.meta.userPage }}</div>
        </div>
      </div>
    </div>
    <div class="userContent">
      <user-information :userData="userData"></user-information>
      <div class="contentBox">
        <div class="userBox" @click="gotoPrivacy1">
          <div class="col1">
            <van-image width="20" height="20" :src="privacy1"></van-image>
            <span class="label">{{ $t.meta.privacy1 }}</span>
          </div>
          <div class="col2">
            <van-image class="iconImg" :src="arrow"></van-image>
          </div>
        </div>
        <div class="userBox" @click="gotoPrivacy2">
          <div class="col1">
            <van-image width="20" height="20" :src="privacy2"></van-image>
            <span class="label">{{ $t.meta.privacy2 }}</span>
          </div>
          <div class="col2">
            <van-image class="iconImg" :src="arrow"></van-image>
          </div>
        </div>
        <div class="userBox" @click="gotoPrivacy3">
          <div class="col1">
            <van-image width="20" height="20" :src="privacy3"></van-image>
            <span class="label">{{ $t.meta.privacy3 }}</span>
          </div>
          <div class="col2">
            <van-image class="iconImg" :src="arrow"></van-image>
          </div>
        </div>
      </div>
      <user-settings></user-settings>
    </div>
  </div>
</template>
<script>
import { Image } from "vant";

import Vue from "vue";
Vue.use(Image);
import UserInformation from "./components/UserInformation";
import UserSettings from "./components/UserSettings";
import { mapGetters } from "vuex";

export default {
  name: "UserManage",
  components: {
    UserInformation,
    UserSettings,
  },
  computed: {
    ...mapGetters(["isLogging"]),
  },
  data() {
    return {
      userData: {},
      privacy1: require("@/assets/img/userManage/privacy1.png"),
      privacy2: require("@/assets/img/userManage/privacy2.png"),
      privacy3: require("@/assets/img/userManage/privacy3.png"),
      arrow: require("@/assets/img/userManage/icon_setting_right@2x.png"),
    };
  },
  beforeMount() {},
  mounted() {
    this.loadHome();
  },
  methods: {
    loadHome() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        let param = {};
        this.$api.home
          .loadPurchasingSystemHome(param)
          .then((res) => {
            this.userData = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject(true);
          });
      });
    },
    gotoPrivacy1() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "privacy1",
        name: "privacy1",
        query: [],
      });
    },
    gotoPrivacy2() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "privacy2",
        name: "privacy2",
        query: [],
      });
    },
    gotoPrivacy3() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "privacy3",
        name: "privacy3",
        query: [],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.userManage {
  $-headerhight: 50px;
  .userHeader {
    position: fixed;
    top: 0;
    left: 0;
    padding-top: calc(env(safe-area-inset-top));
    z-index: 999;
    width: 100%;
    background: linear-gradient(left, #132660, #2750aa);
    .searchBox {
      z-index: 10;
      width: 100%;
      padding: 12.5px 0px;
      text-align: center;
      background: linear-gradient(left, #132660, #2750aa);
      .searchText {
        display: inline-block;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
      }
    }
  }
  .userContent {
    margin-top: $-headerhight;
    display: inline-block;
    width: 100%;
    .contentBox {
      margin: 15px 10px 10px 10px;
      border-radius: 15px;
      border: 1px solid #ebedf0;
      box-shadow: 0px 2px 10px 2px rgb(0 0 0 / 10%);
      .userBox:last-child {
        border: none !important;
      }
      .userBox {
        padding: 4% 0;
        border-bottom: 1px solid #ebedf0;
        .col1 {
          vertical-align: middle;
          display: inline-block;
          width: 85%;
          font-size: 14px;
          font-weight: 500;
          margin-left: 5%;
          .van-image {
            vertical-align: middle;
          }
          .label {
            vertical-align: middle;
            margin-left: 10px;
            line-height: 20px;
            height: 20px;
            display: inline-block;
          }
        }
        .col2 {
          text-align: left;
          vertical-align: top;
          display: inline-block;
          width: 10%;
          .iconImg {
            width: 15px;
            height: 15px;
            object-fit: contain;
            margin-right: 5px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}
</style>
